import React from 'react';
import { SearchIcon, ChevronDownIcon } from 'lucide-react';
import { BodyType, CatalogFilterState, SortOption } from '../types/car';
import { CatalogFilters } from './CatalogFilters';
import { inputClass } from './FormField';
interface CatalogToolbarProps {
  filters: CatalogFilterState;
  onFilterChange: (key: keyof CatalogFilterState, value: string) => void;
  onClearFilters: () => void;
  query: string;
  onQueryChange: (value: string) => void;
  bodyType: BodyType | 'Todos';
  onBodyTypeChange: (value: BodyType | 'Todos') => void;
  sort: SortOption;
  onSortChange: (value: SortOption) => void;
  total: number;
}
const bodyTypes: (BodyType | 'Todos')[] = ['Todos', 'SUV', 'Pickup', 'Sedán', 'Hatchback'];
const sortLabels: Record<SortOption, string> = {
  relevance: 'Destacados',
  'price-asc': 'Menor precio',
  'price-desc': 'Mayor precio',
  'year-desc': 'Más nuevos'
};
export function CatalogToolbar({
  filters,
  onFilterChange,
  onClearFilters,
  query,
  onQueryChange,
  bodyType,
  onBodyTypeChange,
  sort,
  onSortChange,
  total
}: CatalogToolbarProps) {
  return <div className="space-y-4" data-id="element-132" data-mp="28gte1d1ke17z">
      <div className="relative w-full" data-id="element-133" data-mp="28g1uj0l8rty2">
        <SearchIcon className="pointer-events-none absolute left-5 top-1/2 h-6 w-6 -translate-y-1/2 text-neon-electric" aria-hidden="true" data-id="element-134" data-mp="2d8bd1vk11rqb" />
        <label htmlFor="catalog-search" className="sr-only" data-id="element-135" data-mp="2i6d00rkkqb72">
          Buscar vehículo
        </label>
        <input id="catalog-search" type="search" value={query} onChange={e => onQueryChange(e.target.value)} placeholder="Buscar por marca o modelo" className="h-16 w-full rounded-2xl border-2 border-neon-electric bg-raised pl-14 pr-5 text-lg text-white placeholder:text-muted transition-colors duration-150 focus:border-neon focus:outline-none focus:ring-4 focus:ring-neon-electric/30" data-id="element-136" data-mp="1ligow27wo838" />
      </div>
      <CatalogFilters filters={filters} onChange={onFilterChange} onClear={onClearFilters} data-id="element-137" data-mp="3avk5kaig411t" />
    <div className="flex flex-col gap-4 border-y border-line py-4 lg:flex-row lg:items-center lg:justify-between" data-id="element-138" data-mp="2l7o7gc7adji4">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-139" data-mp="2g9morsdrvm76">
        <div role="radiogroup" aria-label="Tipo de carrocería" className="flex flex-wrap gap-1.5" data-id="element-140" data-mp="2v63w88iucgog">
          {bodyTypes.map(type => {
            const active = type === bodyType;
            return <button key={type} type="button" role="radio" aria-checked={active} onClick={() => onBodyTypeChange(type)} className={`h-10 whitespace-nowrap rounded-full border px-4 text-sm font-medium transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-neon ${active ? 'border-neon bg-neon text-ink shadow-neon-btn' : 'border-line bg-panel text-white/80 hover:border-neon/60 hover:text-neon'}`} data-id="element-141" data-mp="22h6qt5zqaed4">
                {type}
              </button>;
          })}
        </div>
      </div>

      <div className="flex items-center justify-between gap-4 lg:justify-end" data-id="element-142" data-mp="3qdea8zlenbnn">
        <p className="text-sm text-muted" aria-live="polite" data-id="element-143" data-mp="3v78uc44x9sn9">
          <span className="font-semibold text-white" data-id="element-144" data-mp="3ght6ox0ou3bs">{total}</span> {total === 1 ? 'vehículo' : 'vehículos'}
        </p>
        <div className="relative" data-id="element-145" data-mp="3lgw7u6djrpeh">
          <label htmlFor="catalog-sort" className="sr-only" data-id="element-146" data-mp="3ldrw8nxr5rds">
            Ordenar por
          </label>
          <select id="catalog-sort" value={sort} onChange={e => onSortChange(e.target.value as SortOption)} className={`${inputClass} h-10 w-44 appearance-none rounded-full pl-4 pr-9`} data-id="element-147" data-mp="hze3i8wzh0it">
            {(Object.keys(sortLabels) as SortOption[]).map(key => <option key={key} value={key} data-id="element-148" data-mp="2opc8mxe7ds3b">
                {sortLabels[key]}
              </option>)}
          </select>
          <ChevronDownIcon className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" aria-hidden="true" data-id="element-149" data-mp="2ss8j20tlahw6" />
        </div>
      </div>
    </div>
    </div>;
}